import React, { Component, Fragment } from 'react';
import api from '../../services/api';
import ModalConfirm from '../common/modal-confirm';
import ModalAlert from '../common/modal-alert';

class Permission extends Component {

    state = {
        load: false,
        users: {},
        sectors: {},
        erroDelete: false,
        insertInstructor: false,
        msgError: null,
        msgSuccess: null,
        idSector: null,
        idUser: null,
        classText: '',
        paginas: 0,
        apiTokens: [],
        showTokenModal: false,
        selectedUserName: '',
        newTokenName: '',
        generatedToken: null
    }

    componentDidMount() {
        this.searchUsers();
        this.searchSectors();
    }

    searchUsers = async (e) => {
        this.setState({ load: true });
        const response = await api.get(`/users`);
        this.setState({ users: response.data.rows, load: false, paginas: Math.ceil(response.data.count / 10) });
    }

    searchSectors = async (e) => {
        this.setState({ load: true });
        const response = await api.get(`/sectors`);
        this.setState({ sectors: response.data.rows, load: false });
    }

    updateUser = (e) => {
        this.setState({ load: false, msgSuccess: null, msgErro: null });
        let user = this.state.users.filter((item) => item.id == e.target.id);
        this.setState({ idUser: e.target.id });
        if (user.length) {
            this.setState({ idSector: user[0].SectorId });
            document.getElementById("nomeUsuario").innerHTML = user[0].name;
            document.getElementById("emailUsuario").innerHTML = user[0].email;
        }
    }

    confirmAlterUsuario = async () => {
        this.setState({ load: true, msgSuccess: null, msgErro: null });
        let sector = document.getElementById("sector").value;
        await api.patch(`/users/${this.state.idUser}`, { SectorId: sector }).then(async (result) => {
            this.setState({ msgSuccess: result.data.msg, msgErro: null });
            this.searchUsers();
            setTimeout(function () {
                document.getElementById("closeModalCreate").click();
            }, 3000);
        });
        this.setState({ load: false });
    }

    openTokenModal = async (userId, userName) => {
        this.setState({ 
            showTokenModal: true, 
            idUser: userId, 
            selectedUserName: userName,
            load: true,
            generatedToken: null
        });
        await this.loadUserTokens(userId);
    }

    loadUserTokens = async (userId) => {
        try {
            const response = await api.get(`/api-tokens/user/${userId}`);
            this.setState({ apiTokens: response.data.data, load: false });
        } catch (error) {
            console.error('Error loading tokens:', error);
            this.setState({ load: false, msgError: 'Erro ao carregar tokens' });
        }
    }

    createToken = async () => {
        if (!this.state.newTokenName.trim()) {
            this.setState({ msgError: 'Nome do token é obrigatório' });
            return;
        }

        this.setState({ load: true, msgError: null });
        try {
            const response = await api.post(`/api-tokens/user/${this.state.idUser}`, {
                name: this.state.newTokenName
            });
            
            this.setState({ 
                generatedToken: response.data.data.token,
                newTokenName: '',
                msgSuccess: 'Token criado com sucesso!'
            });
            await this.loadUserTokens(this.state.idUser);
        } catch (error) {
            console.error('Error creating token:', error);
            this.setState({ msgError: 'Erro ao criar token' });
        }
        this.setState({ load: false });
    }

    toggleToken = async (tokenId) => {
        this.setState({ load: true });
        try {
            await api.patch(`/api-tokens/user/${this.state.idUser}/${tokenId}/toggle`);
            await this.loadUserTokens(this.state.idUser);
            this.setState({ msgSuccess: 'Status do token alterado com sucesso!' });
        } catch (error) {
            console.error('Error toggling token:', error);
            this.setState({ msgError: 'Erro ao alterar status do token' });
        }
        this.setState({ load: false });
    }

    deleteToken = async (tokenId) => {
        if (!window.confirm('Tem certeza que deseja excluir este token?')) {
            return;
        }

        this.setState({ load: true });
        try {
            await api.delete(`/api-tokens/user/${this.state.idUser}/${tokenId}`);
            await this.loadUserTokens(this.state.idUser);
            this.setState({ msgSuccess: 'Token excluído com sucesso!' });
        } catch (error) {
            console.error('Error deleting token:', error);
            this.setState({ msgError: 'Erro ao excluir token' });
        }
        this.setState({ load: false });
    }

    closeTokenModal = () => {
        this.setState({ 
            showTokenModal: false, 
            apiTokens: [], 
            newTokenName: '', 
            generatedToken: null,
            msgError: null,
            msgSuccess: null
        });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Usuários
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <table className="table table-bodered">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Setor</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.users.length) ?
                                        (this.state.users).map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.name}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.Sector.name}</td>
                                                    <td>
                                                        <span data-toggle="modal" data-target=".modal-alter-document" id={item.id} onClick={this.updateUser} className="btn btn-rounded btn-outline-info mr-2">
                                                            <i id={item.id} className="fa fa-edit"></i>
                                                        </span>
                                                        <span onClick={() => this.openTokenModal(item.id, item.name)} className="btn btn-rounded btn-outline-warning">
                                                            <i className="fa fa-key"></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        : null}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>

                <ModalConfirm title="Confirmação" msg="Tem certeza que deseja alterar o usuario?" function={this.confirmDeleteSector} msgError={this.state.erroDelete} />
                <ModalAlert title="Informação" msg={this.state.msgAlert} function="" classText={this.state.classText} />

                <div className="modal fade modal-alter-document" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {(this.state.insertInstructor) ? 'Cadastrar ' : 'Alterar '}
                                    Usuário
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">

                                        <div className="col-md-12">
                                            <span>Nome: </span>
                                            <span id="nomeUsuario"></span>
                                        </div>
                                        <div className="col-md-12">
                                            <span>Email: </span>
                                            <span id="emailUsuario"></span>
                                        </div>

                                        <div className="col-md-12">
                                            <span>Setor <i className="text-danger">*</i></span>
                                            <select className="form-control" id="sector">
                                                {(this.state.sectors.length) ?
                                                    (this.state.sectors).map((item) => {
                                                        return <option value={item.id} selected={item.id == this.state.idSector}>{item.name}</option>
                                                    })
                                                    : null}
                                            </select>
                                        </div>
                                        {(this.state.msgError || this.state.msgSuccess) ?
                                            <div className="col-md-12 p-t-20">
                                                <div className={(this.state.msgSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                                    {this.state.msgError}
                                                    {this.state.msgSuccess}
                                                </div>
                                            </div>
                                            : null}
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}

                                <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmAlterUsuario}>
                                    Alterar
                                </button>

                                <button type="button" id="closeModalCreate" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* API Token Management Modal */}
                {this.state.showTokenModal && (
                    <div className="modal fade show d-block" role="dialog" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Gerenciar Tokens API - {this.state.selectedUserName}
                                        {this.state.load && <i className="fa fa-spin fa-spinner ml-2"></i>}
                                    </h5>
                                    <button type="button" className="close" onClick={this.closeTokenModal}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {/* Create New Token Section */}
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <h6>Criar Novo Token</h6>
                                            <div className="form-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Nome do token"
                                                    value={this.state.newTokenName}
                                                    onChange={(e) => this.setState({newTokenName: e.target.value})}
                                                />
                                            </div>
                                            <button 
                                                className="btn btn-success" 
                                                onClick={this.createToken}
                                                disabled={this.state.load}
                                            >
                                                Criar Token
                                            </button>
                                        </div>
                                    </div>

                                    {/* Generated Token Display */}
                                    {this.state.generatedToken && (
                                        <div className="row mb-4">
                                            <div className="col-md-12">
                                                <div className="alert alert-success">
                                                    <h6>Token Gerado (copie agora, não será mostrado novamente):</h6>
                                                    <code style={{fontSize: '12px', wordBreak: 'break-all'}}>
                                                        {this.state.generatedToken}
                                                    </code>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Existing Tokens */}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h6>Tokens Existentes</h6>
                                            {this.state.apiTokens.length > 0 ? (
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Nome</th>
                                                            <th>Status</th>
                                                            <th>Último Uso</th>
                                                            <th>Criado</th>
                                                            <th>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.apiTokens.map(token => (
                                                            <tr key={token.id}>
                                                                <td>{token.name}</td>
                                                                <td>
                                                                    <span className={`badge ${token.isActive ? 'badge-success' : 'badge-danger'}`}>
                                                                        {token.isActive ? 'Ativo' : 'Inativo'}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {token.lastUsedAt ? 
                                                                        new Date(token.lastUsedAt).toLocaleString('pt-BR') : 
                                                                        'Nunca usado'
                                                                    }
                                                                </td>
                                                                <td>{new Date(token.createdAt).toLocaleString('pt-BR')}</td>
                                                                <td>
                                                                    <button 
                                                                        className={`btn btn-sm ${token.isActive ? 'btn-warning' : 'btn-success'} mr-2`}
                                                                        onClick={() => this.toggleToken(token.id)}
                                                                        disabled={this.state.load}
                                                                    >
                                                                        {token.isActive ? 'Desativar' : 'Ativar'}
                                                                    </button>
                                                                    <button 
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => this.deleteToken(token.id)}
                                                                        disabled={this.state.load}
                                                                    >
                                                                        Excluir
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <p className="text-muted">Nenhum token encontrado.</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Messages */}
                                    {(this.state.msgError || this.state.msgSuccess) && (
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                <div className={`alert ${this.state.msgSuccess ? 'alert-success' : 'alert-danger'}`}>
                                                    {this.state.msgError || this.state.msgSuccess}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary" 
                                        onClick={this.closeTokenModal}
                                    >
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Fragment >
        )
    }

}

export default Permission;